import React from 'react';
import { useState } from 'react';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';
import { Send } from 'lucide-react';
import { Label } from '@/components/ui/label';
import { Textarea } from '@/components/ui/textarea';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const ContactMePage = () => {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    // Handle form submission logic here
    console.log('Form submitted:', { name, email, message });
    try {
      const response = await axios.post(`${API}/contact`, { name, email, message });
      console.log('Message sent successfully:', response.data);
    } catch (error) {
      console.error('Error sending message:', error);
    }
  }

  return (
    <div className="min-h-screen pt-16" data-testid="contactme-page">        
     <section className="py-10 " data-testid="contactme-section">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl font-bold mb-12 text-center">Contact Me</h2>
        </div>
        <form onSubmit={handleSubmit}>
            <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 flex items-center justify-center display: flex flex-col gap-8">
                <Label htmlFor="name" className="text-zinc-300">Name</Label>
                <Input
                    id="name"
                    type="text"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    className="max-w-md bg-zinc-900 border-zinc-800"
                    data-testid="set-name"
                />
                <Label htmlFor="email" className="text-zinc-300">Email</Label>
                <Input
                    id="email"
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    className="max-w-md bg-zinc-900 border-zinc-800"
                    data-testid="set-email"
                />
                <Label htmlFor="message" className="text-zinc-300">Message</Label>
                <Textarea
                    id="message"
                    type="text"
                    value={message}
                    onChange={(e) => setMessage(e.target.value)}
                    className="max-w-md bg-zinc-900 border-zinc-800 h-32"
                    data-testid="set-message"
                />
                <Button
                    type="submit"
                    className="max-w-md bg-emerald-500 hover:bg-emerald-600 text-black font-semibold"
                    data-testid="save-post-btn"
                >
                    <Send className="mr-2 w-4 h-4" />
                    Send Message                  
                  </Button>                            
            </div>
        </form>
     </section>     
    </div>
  );
};

export default ContactMePage;
